module.exports = "<canvas [id]=\"canvasid\"></canvas>\r\n"